import React from 'react';
import { Alert, Col, Row } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import appRoutes from '@/configs/routes';
import { FEATURES_SOURCE_MAP } from '../../../../Featured/pages/PageFeatures/PageFeatures.const';
import PreviewImages from '../../PreviewImages';
import PreviewImageDescription from '../../PreviewImageDescription';
import ImageModalCardHeader from '../ImageModalCardHeader';
import styles from './ImageModalCardBodyView.module.css'



const ImageModalCardBodyView = ({ data }) => {
  const makeAlertMessage = () => {
    const alertElements = [ 'Unpublish is disabled because image is attached:' ];

    if (data?.used_in_collections?.length) {
      alertElements.push(
        ' to collections with ID\'s: ',
        data.used_in_collections.map((id, index) => (
          <React.Fragment key={`collection-${id}`}>
            {index > 0 && ', '}
            <Link
              className={styles.alertMessageDangerLink}
              to={appRoutes.urlPageCollectionDetails({ collectionId: id })}
            >
              {id}
            </Link>
          </React.Fragment>
        )),
        '.',
      );
    }

    if (data?.used_in_editor_choices?.length) {
      alertElements.push(
        ' to editor\'s choices with IDs: ',
        data.used_in_editor_choices.map((id, index) => (
          <React.Fragment key={`editor-choice-${id}`}>
            {index > 0 && ', '}
            <Link
              className={styles.alertMessageDangerLink}
              to={appRoutes.urlPageFeatureDetails({ featureSource: FEATURES_SOURCE_MAP.EDITOR_CHOICE, featureId: id })}
            >
              {id}
            </Link>
          </React.Fragment>
        )),
        '.',
      );
    }

    if (data?.used_in_events?.length) {
      alertElements.push(
        ' to events with IDs: ',
        data.used_in_events.map((id, index) => (
          <React.Fragment key={`event-${id}`}>
            {index > 0 && ', '}
            <Link
              className='alert-message-danger-link'
              to={appRoutes.urlPageEventDetails({ eventId: id })}
            >
              {id}
            </Link>
          </React.Fragment>
        )),
        '.',
      );
    }

    return <span>{alertElements}</span>;
  };

  return (
    <>
      <ImageModalCardHeader data={data} />
      <Row gutter={[ 32, 32 ]} justify="center" className='hp-my-16 hp-border-top-1'>
        <PreviewImages
          icon={data?.icon?.data?.path}
          preview={data?.preview?.data?.path}
        />
        <Col xs={24} md={6}>
          <PreviewImageDescription data={data} />
        </Col>
      </Row>
      {(data?.used_in_collections || data?.used_in_editor_choices || data?.used_in_events) && (
        <Row gutter={[ 32, 32 ]} justify="center">
          <Alert
            className='hp-p-16 hp-mt-8 hp-mb-16'
            title={makeAlertMessage()}
            type="error"
            showIcon
          />
        </Row>
      )}
    </>
  );
};

ImageModalCardBodyView.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.any,
    icon: PropTypes.object,
    preview: PropTypes.object,
    created_at: PropTypes.string,
    data: PropTypes.object,
    source: PropTypes.object,
    categories: PropTypes.object,
    used_in_collections: PropTypes.array,
    used_in_editor_choices: PropTypes.array,
    used_in_events: PropTypes.array,
  }),
  isLoading: PropTypes.bool,
};

export default ImageModalCardBodyView;
